import type { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import i18n from '../config/i18n';

const mapError = (error: string | AxiosError | unknown, options?: any) => {
  if (typeof error === 'string') {
    return i18n.t(error, options);
  }

  const errorData = (error as any)?.response?.data;
  if (errorData) {
    const { errorCode, message } = errorData;
    if (errorCode) {
      const errorTranslationKey = `error.codes.${errorCode}`;

      if (i18n.exists(errorTranslationKey)) {
        return i18n.t(errorTranslationKey);
      }
    }

    if (message) {
      return message;
    }
  }

  return i18n.t('error.response.status.general');
};

export const toastErrorTranslated = (
  error: string | AxiosError | unknown,
  options?: any,
) => {
  toastTranslated(mapError(error, options), 'error');
};

export const toastInfoTranslated = (
  info: string,
  options?: Record<string, any>,
) => {
  toastTranslated(i18n.t(info, options), 'info');
};

export const toastSuccessTranslated = (
  msg: string,
  options?: Record<string, any>,
) => {
  toastTranslated(i18n.t(msg, options), 'success');
};

export const toastWarningTranslated = (
  msg: string,
  options?: Record<string, any>,
) => {
  toastTranslated(i18n.t(msg, options), 'warning');
};

export const toastTranslated = (
  msg: string,
  type: 'success' | 'info' | 'error' | 'warning',
) => {
  return toast[type](msg, {
    theme: 'colored',
    icon: false,
  });
};
